module.exports = __webpack_public_path__ + "img/faro-resort-2.b8918f4d.jpg";